import { Row, Col, Typography } from "antd";
import { getLoggedUser } from "explorer/reducers/users";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

const FormFinish: React.FC<any> = () => {
  const history = useHistory();
  const { t } = useTranslation("radar");

  const dispatch = useDispatch();
  const onFinish = async () => {
    dispatch(getLoggedUser());
    history.push("/tutorial", { tour: true });
  };

  return (
    <Row>
      <Col xs={24}>
        <Typography.Title style={{ fontSize: 50 }}>
          {t("pages.TeamStart.congratulations")}
        </Typography.Title>
      </Col>
      <Col xs={24}>
        <Typography.Title
          style={{ color: "#949494", fontSize: 25, marginBottom: 36 }}
        >
          {t("pages.TeamStart.tutorial")}
        </Typography.Title>
      </Col>

      <Col xs={24} style={{ color: "#fff" }}>
        <button
          style={{ margin: "32px 0" }}
          className="border-preenchido-colorido "
          onClick={onFinish}
        >
          {t("pages.TeamStart.next")}
        </button>
      </Col>
    </Row>
  );
};

export default FormFinish;
